<template>
  <div class="col-12">
    <section-title class="mt-3" content="Firmas del Maestro" :has-line="true" />
    <div v-if="!hasTeacher">
      <span class="my-3 color-gray-6 font-16 text-justify">
        Maestro:
      </span>
    </div>
    <div v-if="!hasTeacher" class="col-3 py-3 px-0">
      <validation-provider v-slot="{ errors }" rules="required">
        <custom-drop-down
          id="teacher"
          ref="teacherSignatureRef"
          v-model="model.teacherSignature"
          custom-error-msg="El maestro es requerido."
          :error="errors[0]"
          fieldkey="id"
          fieldname="name"
          :options="teacherOptions"
          placeholder="Seleccione"
          @input="onChangeTeacher"
        />
      </validation-provider>
    </div>
    <div :class="!hasTeacher ? 'pt-2' : 'pt-0'">
      <div
        v-for="(row, index) of data"
        :key="`signaturesTeacher-item-${index}`"
        class="result-table"
      >
        <div class="row py-2 mr-md-0">
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">
                Nombre:
              </div>
              <div class="color-black font-16 bold">
                {{ row.signatoryName }}
              </div>
            </div>
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Número de Teléfono</div>
              <div class="color-black font-16 bold">
                {{ row.phone | phone }}
              </div>
            </div>
          </div>
          <div class="row pt-2 col-md-6 pl-4">
            <div class="col-md-6">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16 bold">
                {{ row.email }}
              </div>
            </div>
            <div class="col-md-5">
              <div class="color-gray-6 font-14">Rol:</div>
              <div class="color-black font-16 bold">
                {{ row.rol }}
              </div>
            </div>
            <div class="col-md-1 pt-2 text-right">
              <action-button
                v-if="canShowDeleteButton"
                class="btn-action-size-cancel"
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger"
                @click="() => onDelete(row.id, index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import roles from '@/utils/constants/roles.js';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import rpContractStatus from '@/utils/constants/rpContractStatus.js';
import { getSignaturesTeacher as _getSignaturesTeacher } from '@/services/uspqrp/contract.api';
import {
  deleteSignatureHandwritten as _deleteSignatureHandwritten,
  getSignatures as _getSignatures,
} from '@/services/uspqrp/signatures-contractor.api';
import { getcodeRelationshipNameByCode as _getRelationshipNameByCode } from '@/utils/constants/codeRelationship';

export default {
  name: 'SignaturesTeacher',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  mixins: [alertMixin],
  async mounted() {
    await this.getSignaturesTeacher();
    this.teachers = this.teachersUpdated;
    this.teacherOptions = this.teachersUpdated.map((teacher) => ({
      name: teacher.signatoryName,
      id: teacher.userId,
      sortOrder: 0,
      selected: false,
      disabled: false,
      isDirty: false,
    }));
  },
  data: () => ({
    model: {
      teacherSignature: null,
    },
    data: [],
    teacherOptions: [],
    teachers: [],
    hasTeacher: false,
  }),
  props: {
    academicYearId: {
      type: Number,
      default: 0,
      required: false,
    },
    studentSieId: {
      type: Number,
      default: 0,
      required: false,
    },
    contractId: {
      type: Number,
      default: 0,
      required: false,
    },
    contractStatusId: {
      type: Number,
      default: 0,
      required: false,
    },
    signaturesUpdatedTeacher: {
      type: Array,
      default: () => [],
    },
    contractInformationModel: {
      type: Object,
      default: () => {},
    },
    teachersUpdated: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    canShowDeleteButton() {
      const validStatus = [
        rpContractStatus.New,
        rpContractStatus.InSigningProcess,
      ];

      return validStatus.includes(this.contractStatusId);
    },
  },
  methods: {
    async getTeacherRRHH() {
      this.data = (
        await _getSignaturesTeacher(
          this.academicYearId,
          this.contractInformationModel.StudentSchoolId,
          this.studentSieId
        )
      ).data;

      this.hasTeacher = this.data && this.data.length > 0;

      if (this.hasTeacher) {
        const teacherToSave = this.data[0];
        const newSignature = {
          signatoryname: teacherToSave.signatoryName,
          contractid: this.contractId,
          email: teacherToSave.email,
          phone: teacherToSave.phone,
          userId: teacherToSave.userId,
          roleId: teacherToSave.roleId,
          check: true,
          isProvider: false,
        };
        this.$emit('update-signatures-teacher', [newSignature]);
      }
    },
    async getSignaturesTeacher() {
      if (this.contractId != null) {
        const signaturesSaved = (await _getSignatures(this.contractId)).data;

        if (signaturesSaved && signaturesSaved.length > 0) {
          const signatureTeacher = signaturesSaved.filter(
            (signature) =>
              signature.roleId !== null &&
              signature.roleId.toLowerCase() === roles.Teacher.toLowerCase()
          );

          if (signatureTeacher && signatureTeacher.length > 0) {
            this.data = [
              {
                signatoryName: signatureTeacher[0].signatoryName,
                email: signatureTeacher[0].email,
                phone: signatureTeacher[0].phone,
                rol: this.getRelationshipName(
                  signatureTeacher[0].relationTypeId
                ),
                id: signatureTeacher[0].id,
              },
            ];
            this.hasTeacher = true;
          } else {
            await this.getTeacherRRHH();
          }
        } else {
          await this.getTeacherRRHH();
        }
      }
    },
    async onChangeTeacher() {
      if (
        this.model.teacherSignature !== undefined &&
        this.model.teacherSignature !== null
      ) {
        const selectedTeacher = this.teachers.find(
          (teacher) => teacher.userId === this.model.teacherSignature.id
        );

        if (selectedTeacher) {
          this.data = [
            {
              signatoryName: selectedTeacher.signatoryName,
              email: selectedTeacher.email,
              phone: selectedTeacher.phone,
              rol: selectedTeacher.rol,
            },
          ];
          this.hasTeacher = true;

          const newSignature = {
            signatoryname: selectedTeacher.signatoryName,
            contractid: this.contractId,
            email: selectedTeacher.email,
            phone: selectedTeacher.phone,
            userId: selectedTeacher.userId,
            roleId: selectedTeacher.roleId,
            check: true,
            isProvider: false,
          };

          this.$emit('update-signatures-teacher', [newSignature]);
        }
      } else {
        this.data = [];
      }
    },
    async onDelete(id, index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea remover el maestro?`,
        'Sí',
        'No'
      );

      if (answer) {
        if (id !== undefined && id !== null) {
          await _deleteSignatureHandwritten(id);
          this.data = this.data.filter((signature) => signature.id !== id);
          this.$emit('update-signatures-teacher', this.data);
        } else {
          this.data.splice(index, 1);
          this.$emit('update-signatures-teacher', this.data);
        }
        this.hasTeacher = false;
        this.model.teacherSignature = null;
      } else {
        return;
      }
    },
    getRelationshipName(code) {
      return _getRelationshipNameByCode(code);
    },
  },
  watch: {
    signaturesUpdatedTeacher(signaturesSaved) {
      if (signaturesSaved && signaturesSaved.length > 0) {
        const signatureTeacher = signaturesSaved.filter(
          (signature) =>
            signature.roleId !== null &&
            signature.roleId?.toLowerCase() === roles.Teacher.toLowerCase()
        );

        if (signatureTeacher && signatureTeacher.length > 0) {
          this.data = [
            {
              signatoryName: signatureTeacher[0].signatoryName,
              email: signatureTeacher[0].email,
              phone: signatureTeacher[0].phone,
              rol: this.getRelationshipName(signatureTeacher[0].relationTypeId),
              id: signatureTeacher[0].id,
            },
          ];
          this.hasTeacher = true;
        }
      } else {
        this.getSignaturesTeacher();
      }
    },
    teachersUpdated(teachers) {
      this.teachers = teachers;
      this.teacherOptions = teachers.map((teacher) => ({
        name: teacher.signatoryName,
        id: teacher.userId,
        sortOrder: 0,
        selected: false,
        disabled: false,
        isDirty: false,
      }));
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.result-table {
  padding-left: 20px;
  background-color: #f7f7f7;
  border-bottom: 1px solid darkgray;
}
.row-message {
  border: 1px solid #f3af54;
  margin-bottom: 0px !important;
}
.btn-action-size-cancel {
  width: 40px;
  height: 40px;
}
</style>
